import { FileDragDrop } from 'components/FileDragDrop'
import { Modal } from 'components/UI/Modal/Modal'
import { Spinner } from 'react-bootstrap'
import { ImporterColumnAssignModal } from './ImporterColumnAssignModal'
import { ImporterProvider, useImporterViewModel } from './ImporterViewModel'

interface ImporterUploadProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function ImporterUpload({ open, onOpenChange }: ImporterUploadProps) {
  return (
    <ImporterProvider importNumber={null}>
      <ImporterUploadModal open={open} onOpenChange={onOpenChange} />
    </ImporterProvider>
  )
}

function ImporterUploadModal({ open, onOpenChange }: ImporterUploadProps) {
  const viewModel = useImporterViewModel()

  return (
    <Modal
      open={open}
      onCancel={() => onOpenChange(false)}
      onOpenChange={onOpenChange}
      title="Start New Import"
      description="Start a new import by uploading a CSV file."
      size="lg"
      blockCancel={viewModel.isSaving}
      disableCloseIcon={viewModel.isSaving}
    >
      <div className="border-2 border-dashed border-gray-300 rounded-md p-4 flex flex-col w-full h-full justify-center items-center">
        <div className="p-4 w-full">
          {viewModel.isSaving ? (
            <div className="flex flex-col items-center justify-center py-8">
              <Spinner animation="border" />
              <div className="mt-4 text-sm text-gray-600">
                Uploading and processing your file...
              </div>
            </div>
          ) : (
            <FileDragDrop
              file={viewModel.rawFile}
              onFileChange={viewModel.handleFileUpload}
            />
          )}
        </div>
        <ImporterColumnAssignModal
          data={viewModel.importData}
          open={viewModel.showHeaderMappingModal}
          onClose={() => viewModel.setShowHeaderMappingModal(false)}
          onSave={async (data) => {
            viewModel.setShowHeaderMappingModal(false)
            await viewModel.handleSave(data)
          }}
        />
      </div>
    </Modal>
  )
}
